'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _jsx = require('@babel/runtime/helpers/jsx');
require('react');
require('prop-types');
var badge = require('@andes/badge');
var ContentDates = require('@seo-frontend-components/content-dates');
var jsxRuntime = require('react/jsx-runtime');
const namespace = 'seo-ui-blog-headers';
const BlogHeaders = props => {
  const {
    datesData,
    tags
  } = props;
  const formattedTags = (tags === null || tags === void 0 ? void 0 : tags.map(tag => ({
    name: tag.name.toUpperCase(),
    url: tag.url
  }))) || [];
  const renderTag = tag => {
    return /*#__PURE__*/_jsx("a", {
      href: `${tag.url}`
    }, tag.name, /*#__PURE__*/_jsx(badge.Pill, {
      size: "small",
      hierarchy: "quiet",
      className: `${namespace}-tag`
    }, tag.name, tag.name));
  };
  const renderTags = tags => tags.map(tag => renderTag(tag));
  const TagsComponent = _ref => {
    let {
      tags
    } = _ref;
    return /*#__PURE__*/_jsx("div", {
      className: `${namespace}-tags-container`
    }, void 0, renderTags(tags));
  };
  return /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/jsxRuntime.jsx(ContentDates, _objectSpread({}, datesData)), formattedTags.length > 0 && /*#__PURE__*/_jsx(TagsComponent, {
    tags: formattedTags
  }));
};
BlogHeaders.displayName = 'BlogHeaders';
exports.default = BlogHeaders;
